import React from "react";
import { Grid } from "@mui/material";
import { makeStyles } from "@material-ui/core";
import { Typography } from "@mui/material";
import styles from "./styles";

const useStyles = makeStyles(styles);

export const GasMovTableHeaders = ({title, titles}) => {
  const classes = useStyles();
  return (
    <>
      <Grid item xs={12} className={classes.title}> 
        <Typography className={classes.titleText}>
          {title}
        </Typography>
      </Grid>
      {
        titles.map(title => (
          <Grid item xs={3} className={classes.cell}>
            <Typography className={classes.headerText}>
              {title}
            </Typography>
          </Grid>
        ))
      }
    </>
  );
};
